import template from './previousLink.html';
import controller from './previousLink.controller';
import './previousLink.scss';

let previousLinkComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  transclude: true
};

export default previousLinkComponent;
